// @index(['./!(*.spec).ts', './*/index.ts'], f => `export * from '${f.path.replace(/\/index$/, '')}';`)
export * from './apple-market.service';
export * from './google-market.service';
export * from './iap-market.service';
export * from './market.adapter';
export * from './noop-market.service';
export * from './stripe-market.service';
// @endindex